import Link from 'next/link';

type Props = {
  title: string;
  links: {
    title: string;
    path: string;
    isOpenInNewWindow?: boolean;
    id?: string;
  }[];
  classes?: string;
};

const LinksList = ({ title, links, classes }: Props) => {
  const linkItems = links.map((item, index) => {
    // CookieYes opens its preferences panel from any `cky-banner-element`.
    if (item?.id) {
      return (
        <li key={`${item}_${index}`}>
          <button
            type="button"
            className="text-xs pt-2 cursor-pointer text-neutral-50 hover:text-neutral-200 cky-banner-element"
            id={item.id}
          >
            {item.title}
          </button>
        </li>
      );
    }
    if (item.isOpenInNewWindow) {
      return (
        <li key={`${item}_${index}`}>
          <a
            href={item.path}
            target="_blank"
            className="text-xs text-neutral-50 hover:text-neutral-200"
            rel="noreferrer"
          >
            {item.title}
          </a>
        </li>
      );
    }
    return (
      <li key={`${item}_${index}`}>
        <Link
          href={item?.path}
          className="text-xs text-neutral-50 hover:text-neutral-200"
        >
          {item.title}
        </Link>
      </li>
    );
  });

  return (
    <div data-cy="links-list" className={`${classes ? classes : ''}`}>
      <h3 className="text-xs font-bold text-neutral-50">{title}</h3>
      <ul className="mt-2 space-y-2">{linkItems}</ul>
    </div>
  );
};

export default LinksList;
